<template>
  <div id="pdf"></div>
</template>

<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
export default {
  name: 'pdf',
  data() {
    return {url: ''}
  },
  mounted() {
    const url2 = this.$route.query.url
    if (url2) {
      // this.url = this.$isCdn(url2)
      this.url = `https://wljy.scsjky.cn/${url2}`
      setTimeout(() => {
        console.log('this.url', this.url)
        this.pdfh5 = new Pdfh5('#pdf', {
          pdfurl: this.url
        })
        this.pdfh5.on('complete', (status, msg, time) => {
          console.log('状态：' + status + '，信息：' + msg + '，耗时：' + time + '毫秒，总页数：' + this.totalNum)
        })
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
#pdf {
  width: 100%;
  height: 100vh;
  overflow: auto;
}
</style>
